import React from "react";
import {Field, Form} from "react-final-form";
import RowLayout from "../../common/components/elements/container/row";
import ColumnLayout from "../../common/components/elements/container/column";
import {FormContainer} from "../../common/components/collections/form/forms";
import {PrimaryLoadingButton} from "../../common/components/elements/button/PrimaryButton";
import useAuthentication from "src/core/authentication/hooks/useAuthentication";
import Error from "../../common/components/elements/Error";
import AuthErrors from "../../authentication/components/AuthErrors";
import PasswordInput from "../../common/components/elements/input/PasswordInput";
import {showErrorHighlight} from "src/core/common/utils";

function ChangePasswordForm({builder, onFinish}) {
  const [authState] = useAuthentication();

  function onSubmit(formValues) {
    builder
      .setCurrentPassword(formValues.currentPassword)
      .setPassword(formValues.password)
      .setConfirmPassword(formValues.password);
    onFinish();
  }

  return (
    <Form
      onSubmit={onSubmit}
      validate={() => {}}
      render={({handleSubmit}) => (
        <form onSubmit={handleSubmit}>
          <AuthErrors />
          <FormContainer>
            <ColumnLayout>
              <RowLayout>
                <Field
                  name="currentPassword"
                  render={({input, meta}) => (
                    <>
                      <PasswordInput
                        {...input}
                        hasErrors={showErrorHighlight(meta)}
                        placeholder={"Current password"}
                      />
                      {meta.touched && <Error>{meta.error}</Error>}
                    </>
                  )}
                />
              </RowLayout>
            </ColumnLayout>
            <ColumnLayout>
              <RowLayout>
                <Field
                  name="password"
                  render={({input, meta}) => (
                    <>
                      <PasswordInput
                        {...input}
                        hasErrors={showErrorHighlight(meta)}
                        placeholder={"Enter new password"}
                      />
                      {meta.touched && <Error>{meta.error}</Error>}
                    </>
                  )}
                />
              </RowLayout>
            </ColumnLayout>
            <PrimaryLoadingButton
              loading={authState.loading}
              label="Save"
              type="submit"
            />
          </FormContainer>
        </form>
      )}
    />
  );
}

export default ChangePasswordForm;
